import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export const Title = (props: any): JSX.Element => {
  return (
    <Typography component="h2" variant="h6" color="primary"
     style={{ display: 'flex', justifyContent: 'space-between' }}
     gutterBottom>
      {props.children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;